import { PayoutColumnToSort } from "@/modules/finances/utils/financeUtils"
import { ColumnSortingOrder } from "@/modules/types/datatableTypes"
import { LoggerService } from "@modules/common/logger/loggerService"
import { ApiClient } from "@modules/core/api/client/apiClient"
import { type PayoutApiGateway } from "@modules/finances/financesPayout/gateway/payoutApiGateway"
import {
  type PayoutDetailsDto,
  PayoutDetailsDtoSchema,
  type PayoutItemDto,
  PayoutItemDtoSchema,
} from "@modules/finances/financesPayout/gateway/payoutDto"
import { type Paginated, toPage } from "@modules/utils/paginated"

export enum PayoutEnumApi {
  OWNER = "OWNER",
  ATHLETE = "ATHLETE",
}

export class PayoutApi implements PayoutApiGateway {
  private baseBoxUrl = "/box/financial"
  private baseAtheleUrl = "/financial"

  private getBaseUrl = (api: PayoutEnumApi) => {
    switch (api) {
      case PayoutEnumApi.OWNER:
        return this.baseBoxUrl
      case PayoutEnumApi.ATHLETE:
        return this.baseAtheleUrl
    }
  }

  constructor(private api: ApiClient) {}

  async getPayouts(
    api: PayoutEnumApi,
    page: number,
    size?: number,
    sortBy: PayoutColumnToSort = PayoutColumnToSort.LAUNCHED,
    sortOrder: ColumnSortingOrder = ColumnSortingOrder.DESC,
  ) {
    const result = await this.api.get<Paginated<PayoutItemDto>>(`${this.getBaseUrl(api)}/payouts`, {
      params: { page, size, sort: `${sortBy},${sortOrder}` },
    })

    const pageData = toPage(result.data)

    return {
      ...pageData,
      content: pageData.content.map((payout) => LoggerService.parseApiDto(PayoutItemDtoSchema, payout)),
    }
  }

  async getPayout(api: PayoutEnumApi, payoutId: string): Promise<PayoutDetailsDto> {
    const result = await this.api.get<PayoutItemDto>(`${this.getBaseUrl(api)}/payouts/${payoutId}`)
    return LoggerService.parseApiDto(PayoutDetailsDtoSchema, result.data)
  }
}
